import { render, staticRenderFns } from "./_DeviceTable.vue?vue&type=template&id=6844ae31&scoped=true"
import script from "./_DeviceTable.vue?vue&type=script&lang=ts"
export * from "./_DeviceTable.vue?vue&type=script&lang=ts"
import style0 from "./_DeviceTable.vue?vue&type=style&index=0&id=6844ae31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844ae31",
  null
  
)

export default component.exports